import { getAsync, sleep } from './apiHelper';
import DemoData from '../data/demoData.json';

const endpoint = process.env.VUE_APP_BACKEND;
const demoData = DemoData;

export async function getAllActivitesByActionAndLocationAsync(actionId, locationId, startAfter, startBefore, slug) {
    let result = null;
    if (slug !== "demo") {
        if (locationId) result = await getAsync(`${endpoint}?slug=${slug}&type=getActivities&action=${actionId}&isCancelled=false&startAt[before]=${startBefore}&startAt[after]=${startAfter}&location=${locationId}`);
        else result = await getAsync(`${endpoint}?slug=${slug}&type=getActivities&action=${actionId}&isCancelled=false&startAt[before]=${startBefore}&startAt[after]=${startAfter}`);
        return result;
    }
    else {
        await sleep(300);
        return demoData["activities"];
    }
}
